<template>
  <div>
    <QuestionRadioOptions
      group="region"
      :item="region_options"
      @selected="region_selected"
    />
    
    <div class="mt-8" v-if="region_company_id">
      <QuestionRadioOptions 
        group="company"
        :item="company_options"
        @selected="company_selected"
      />    
    </div>
    
    <p v-if="show_error" class="mt-8" style="color: #fd397a;">{{ $t('PUBLIC.FORM.MISSING_FIELDS') }}</p>

    <div v-if="show_buttons" class="d-sm-flex justify-content-end align-items-center align-bottom w-100 mt-4">
      <memlist-button
        v-if="form_page.index != 0"
        variant="secondary"
        @click="on_back"
        size="lg"
        class="mr-4">
        {{ $t('COMMON.BACK') }}
      </memlist-button>

      <memlist-spinner-icon-button
        ref="next-button"
        size="lg"
        :text="$t('COMMON.CONTINUE')" 
        :disabled="local_input_data.company_ids.length === 0"
        icon="menu-icon flaticon2-arrow"
        @click="on_click"
      />
      
    </div>

  </div>
</template>

<script>
/**
 * Special company select when you have a region above.
 */

import dayjs from 'dayjs';

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import ExtraCompanyMultipleOptions from '@/view/pages/members/register/registerwizard/company_select_v2/ExtraCompanyMultipleOptions.vue';
import ExtraCompanySingleOption from '@/view/pages/members/register/registerwizard/company_select_v2/ExtraCompanySingleOption.vue';
import axios from 'axios';
import QuestionRadioOptions from '@/view/components/questions/QuestionRadioOptions.vue';


export default {
  name: 'FormPageCompanyRegionSelect',
  mixins: [ toasts ],

  props: {
    show_buttons: {
      type: Boolean,
      default: true
    },

    input_data: { /* data for the entire form, previously entered, all pages */
      type: Object,
      default: () => ({})
    },

    form_page: { /* page definition for this page, ml_form_page */
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    
  },
  

  components: {
    QuestionRadioOptions
  },

  data() {
    return {
      local_input_data: null,
      region_company_id: null,
      selected_company_id: null,

      company_options: {
        name: this.$t('PUBLIC.FORM.SELECT_COMPANY'),
        options: [ 
          { value: 'abc1231', text: 'Förening A' }, 
          { value: 'abc1232', text: 'Förening B' } 
        ]
      },

      region_options: {
        name: this.$t('PUBLIC.FORM.SELECT_REGION'),
        options: [ 
          { value: 'abc1231', text: 'Förening A' }, 
          { value: 'abc1232', text: 'Förening B' } 
        ]
      },

      skip: false,

      force_validate: 0,
      is_form_valid: false,
      show_error: false,
      spinning: false,
      disabled: false,
      type: 'primary'
    };
  },
  mounted() {

  },
  watch: {
    input_data: {
      handler(newValue) {
        
        this.local_input_data = { ...this.input_data }

        if (this.local_input_data.company_ids === undefined) {
          this.local_input_data.company_ids = []; 
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {

    async region_selected(value) {
      this.region_company_id = value;
    },
    
    async company_selected(value) {
      if (!value) {
        return;
      }

      this.selected_company_id = value;

      this.local_input_data.company_ids = [this.selected_company_id];

      this.local_input_data = { ...this.local_input_data };
    },

    on_back() {
      this.$emit('back', this.form_page, this.local_input_data);
    },

    skip_clicked() {},

    update_form(field_name, value) {
      this.local_input_data[field_name] = value;

      this.local_input_data = { ...this.local_input_data };
    },
    validated(field_name, value, valid) {
      this.local_input_data[field_name] = value;

      if (!valid) {
        this.is_form_valid = false;
      }
    },

    async on_click() {
      this.spinning = true;
      this.show_error = false;

      if (this.local_input_data.company_ids.length === 0) {
        this.is_form_valid = false;
      }

      this.is_form_valid = true;
      this.force_validate = this.force_validate + 1;

      this.$nextTick(()=>{
        if (this.is_form_valid) {
          this.spinning = false;

          this.$refs['next-button'].stop();
          this.$emit('next', this.form_page, this.local_input_data);
        }
        else {
          this.show_error = true; 

          setTimeout(()=>{
            this.spinning = false;
            this.$refs['next-button'].stop();
          }, 500);
        }
      });
    },

  }
};
</script>


<style lang="css" scoped>

</style>
